/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const updateOrganisationAccessModeDataAccessMode = {
	implicit: 'implicit',
	explicit: 'explicit',
} as const

export type UpdateOrganisationAccessModeDataAccessMode =
	(typeof updateOrganisationAccessModeDataAccessMode)[keyof typeof updateOrganisationAccessModeDataAccessMode]
